import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { Checkbox } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function CheckboxRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  return (
    <Checkbox
      checked={value === true}
      onChange={(e) => onChange(e.value === true)}
      disabled={readOnly}
      label={field.label}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'CHK',
  label: 'Checkbox',
  category: 'input',
  icon: <FontAwesomeIcon icon={faSquareCheck} fixedWidth />,
  defaultProps: { label: 'New checkbox', isRequired: false },
  Renderer: CheckboxRenderer,
};
